import React from "react";
import {
  Alert,
  Form,
  Icon,
  Input,
  Button,
  Row,
  Col,
  Select,
  Checkbox,
  InputNumber,
} from "antd";

import get from "lodash/get";
import find from "lodash/find";
import filter from "lodash/filter";
import map from "lodash/map";
import { connect } from "react-redux";

import classes from "./SpecimenSamplesSettingsForm.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import {
  createSampleSetting,
  updateSampleSetting,
  getForms,
  getEventsManagementList,
} from "../../api/requests";

class SpecimenSamplesSettingsForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      forms: [],
      events: [],
      requestResult: {},
    };
  }

  async componentDidMount() {
    try {
      const { data } = await getForms();
      const { data: events } = await getEventsManagementList();
      this.setState({ forms: data, events });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          console.log(this.state.forms);
          console.log(values);

          const eventBody = {
            ...find(this.state.events, ({ id }) => id === values.event),
          };
          const event = {
            name: eventBody.name,
            id: eventBody.id,
          };

          const data = {
            name: values.name,
            event,
            collection_form_schemas: map(
              values.collection_form_schemas,
              (idCollection, index) => ({
                order_index: index + 1,
                form: find(this.state.forms, ({ id }) => id === idCollection),
              })
            ),
            result_form_schemas: map(
              values.result_form_schemas,
              (idResult, index) => ({
                order_index: index + 1,
                form: find(this.state.forms, ({ id }) => id === idResult),
              })
            ),
          };

          this.props.id
            ? await updateSampleSetting(data, this.props.id)
            : await createSampleSetting(data);

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }

          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );

            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { isPredefined } = this.props;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.i18n.t(
              "NamespaceSpecimenSample:Sample Settings"
            )}
          </h4>

          <Row gutter={12}>
            <Col span={24}>
              <label>
                <Form.Item
                  required
                  label={this.props.i18n.t(
                    "NamespaceSpecimenSample:Specimen Sample Name"
                  )}
                >
                  {getFieldDecorator("name", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "name"),
                  })(<Input type="text" disabled={isPredefined} />)}
                </Form.Item>
              </label>
            </Col>
            <Col span={24}>
              <label>
                <Form.Item
                  required
                  label={this.props.i18n.t(
                    "NamespaceSpecimenSample:Event"
                  )}
                >
                  {getFieldDecorator("event", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "event.id"),
                  })(
                    <Select>
                      {this.state.events.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={24}>
              <label>
                <Form.Item
                  required
                  label={this.props.i18n.t(
                    "NamespaceSpecimenSample:Collection form schemas"
                  )}
                >
                  {getFieldDecorator("collection_form_schemas", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(
                      this.props,
                      "collection_form_schemas",
                      []
                    ).map((item) => item.form.id),
                  })(
                    <Select mode="multiple">
                      {this.state.forms.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={24}>
              <label>
                <Form.Item
                  label={this.props.i18n.t(
                    "NamespaceSpecimenSample:Result form schemas"
                  )}
                >
                  {getFieldDecorator("result_form_schemas", {
                    initialValue: get(
                      this.props,
                      "result_form_schemas",
                      []
                    ).map((item) => item.form.id),
                  })(
                    <Select mode="multiple">
                      {this.state.forms.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <br />

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            }

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {isPredefined
                ? this.props.i18n.t("Close")
                : this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = { logout };

export default Form.create({ name: "sample-settings" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SpecimenSamplesSettingsForm))
);



// WEBPACK FOOTER //
// ./src/containers/SpecimenSamplesSettings/SpecimenSamplesSettingsForm.js